'use client'

import React from 'react'
import excel from 'exceljs'
import { saveAs } from 'file-saver'

import { Button } from '@/components/ui'
import { TablerFileTypeXls } from '@/components/ui/icons'

interface ExportOrderItemsReportProps {
  items: any[]
}

export const ExportOrderItemsReport = ({
  items,
}: ExportOrderItemsReportProps) => {
  const exportReport = async () => {
    try {
      const workbook = new excel.Workbook()
      const worksheet = workbook.addWorksheet('Order Items Report')

      // Define columns with more formatting options
      worksheet.columns = [
        { header: 'Product Name', key: 'productName', width: 30 },
        { header: 'Sold Qty', key: 'soldQuantity', width: 15 },
        { header: 'Price', key: 'price', width: 15 },
        { header: 'Sold Addons Qty', key: 'soldAddonsQty', width: 15 },
        { header: 'Inventory Qty', key: 'inventoryQty', width: 15 },
        { header: 'Return Qty', key: 'returnQty', width: 15 },
        { header: 'Total Sold Amount', key: 'totalSoldAmount', width: 15 },
      ]

      // Style the header row
      worksheet.getRow(1).font = { bold: true }
      worksheet.getRow(1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }

      // Add rows with formatting
      for (const item of items) {
        const row = worksheet.addRow({
          productName: item.product_name,
          soldQuantity: item.total_item_sold_qty,
          price: item.price,
          soldAddonsQty: item.total_addons_sold_qty,
          inventoryQty: item.total_inventory_qty,
          returnQty: item.total_return_qty,
          totalSoldAmount: item.total_item_sold_price,
        })

        // Set alignment for each cell in the row
        row.alignment = { vertical: 'middle', horizontal: 'left' }
        row.getCell('soldQuantity').alignment = {
          vertical: 'middle',
          horizontal: 'center',
        }
        row.getCell('price').alignment = {
          vertical: 'middle',
          horizontal: 'center',
        }
      }

      // Auto-fit columns
      for (const column of worksheet.columns) {
        column.width = column.width || 15
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const fileName = `stock-report-${new Date().toISOString().split('T')[0]}.xls`
      saveAs(blob, fileName)
    } catch (error) {
      console.error('Error exporting report:', error)
    }
  }

  return (
    <div>
      <Button size="sm" variant="outline" onClick={exportReport}>
        <TablerFileTypeXls className="!size-5" />
        Export Report
      </Button>
    </div>
  )
}
